import { createBrowserHistory } from 'history';
import { Route } from 'react-router-dom';

import { initializeFaro, getWebInstrumentations, LogLevel, ReactIntegration, faro, createReactRouterV5Options } from '@grafana/faro-react';

const history = createBrowserHistory();

const getFaroConfig = () => {
  switch (process.env.REACT_APP_NODE_ENV) {
    case 'production':
      return {
        name: 'localyser_PROD_landing',
        environment: 'production'
      };

    case 'staging':
      return {
        name: 'localyser_STG_landing',
        environment: 'staging'
      };

    case 'localhost':
    default:
      return {
        name: 'localyser_DEV_landing',
        environment: 'development'
      };
  }
};

const initFaro = () => {
  if (faro && faro.api) {
    // Faro is already initialized, skipping re-initialization
    return;
  }

  const faroConfig = getFaroConfig();

  initializeFaro({
    url: 'https://alloy-faro.localyser.com/collect',
    app: {
      ...faroConfig,
      version: '1.0.0'
    },

    trackResources: false,

    batching: {
      enabled: true,
      sendTimeout: 10000,
      itemLimit: 30
    },

    // Ignore non-critical errors and React dev warnings
    ignoreErrors: [/Warning:/, /Error fetching data: SyntaxError: Unexpected token/],

    beforeSend: item => {
      if (item.type === LogLevel.LOG && item.payload?.level === LogLevel.WARN) {
        return null;
      }

      return item;
    },

    consoleInstrumentation: {
      disabledLevels: [LogLevel.WARN, LogLevel.LOG, LogLevel.DEBUG, LogLevel.TRACE]
    },

    instrumentations: [
      ...getWebInstrumentations(),

      new ReactIntegration({
        router: createReactRouterV5Options({
          history,
          Route
        })
      })
    ]
  });
};

export default initFaro;
